import React from 'react';

import classNames from 'classnames';

export function DropOverlay() {
  return (
    <div
      className={classNames(
        'position-absolute top-0 start-0 bottom-0 end-0',
        'd-flex align-items-center justify-content-center',
        'bg-light border border-dashed rounded-3 text-muted',
      )}
      style={{ pointerEvents: 'none', zIndex: 1 }}
    >
      Drop files to attach
    </div>
  );
}
